export default {
      id: "icon-difficulte1-usage",
      viewBox: "0 0 915 275",
      url: __webpack_public_path__ + "icons.svg#icon-difficulte1",
      toString: function () {
        return this.url;
      }
    }